baseURL = $('#gtm-pdp-products').attr('data-actionurl');

const fetchProduct = (pid) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: baseURL + pid,
      method: 'GET',
      success: function (data) {
         resolve(data);
      },
      error: function () {
        reject(error)
      }
    });
  });
}

module.exports = {
  fetchProduct
}